import { ROOT_INTERNA, ROOT_EXTERNA } from './../../utils/constants';
import { Injectable } from '@angular/core';
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class ExternalAccesoGuard {

  constructor(private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    // console.log(state.url);
    let url = state.url;
    let regex = new RegExp(ROOT_INTERNA + "/");
    //Si accedemos a un login desde la ruta /internal redirigimos a home
    if (regex.test(url)) {
      url = url.replace('/acces', '/home');
      this.router.navigate([url]);
      return false;
    }
    else
      return true;
  }
}
